import React from 'react';
import { Outlet } from 'react-router-dom';
import TripSubNavigation from '../../components/trip-match-sub-navigation';

const TripMatchMain = () => (
  <>
    <TripSubNavigation />
    <Outlet />
  </>
);

export default TripMatchMain;
